import { makeRequest } from "./api";

export const CreateFee = async (data) => {
  return makeRequest("/api/admin/manage/fee/create", {
    method: "POST",
    data,
  });
};

export const UpdateFee = async (data) => {
  return makeRequest(`/api/admin/manage/fee/update`, {
    method: "PUT",
    data,
  });
};

export const DeleteFee = async (feeId) => {
  return makeRequest(`/api/admin/manage/fee/remove/${feeId}`, {
    method: "DELETE",
  });
};

export const FetchFeeByType = async (type) => {
  return makeRequest(`/api/admin/manage/fee/fetchByType/${type}`);
};
